<div name="resultsDiv" id="resultsDiv" *ngIf="productDetails?.length > 0" class="product-details-main-container">
  <div class="product-details-container clearfix" *ngIf="layoutType === 'grid'"
    [class.grid-bottom-margin]="setBottomMargin">
    <div class="product-details-grid-tile grid-tile-spacing"
      *ngFor="let productDetail of productDetails; let i = index">
      <div kuiText *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{
        'featured' |
        translate }}</div>
      <div kuiText *ngIf="!productDetail.isFeaturedProduct" class="product-details-featured-product image-cont"
        style="visibility: hidden">{{ 'featured' | translate }}</div>
      <div style="position: relative;">
        <div class="product-details-image-container">
          <kui-image aspectRatio="1-1">
            <img title="{{productDetail.productVariationName}} " src="{{productDetail.imageUrl}}"
              alt="{{productDetail.productVariationName}}" (load)="createThumbnail($event.target)"
              (error)="showImgError($event.target)" />
          </kui-image>
        </div>
        <h2 kuiText class="product-name h--smallest" id="pt-{{productDetail.productId}}">
          {{productDetail.productVariationName}}
        </h2>
        <div class="specs-container 30"
          [ngClass]="{'specs-container-grid-laptop': productDetail.category === 'LAPTOP'}">
          <ul>
            <li *ngFor="let specs of productDetail.productInfo">
              <div class="specs p-medium" *ngIf="specs.value!=='--' && specs.value!==''">
                <div kuiText style="display: inline-block;">{{specs.name | translate}}:</div>
                <div kuiText style="display: inline-block;">{{specs.value}}</div>
              </div>
            </li>
          </ul>
        </div>
        <div #drSpinnerCont *ngIf="productDetail.digitialRiverID==='4fs|~'" class="dr-spinner-bg-grid 37">
          <div #drId *ngIf="productDetail.digitialRiverID" class="product-row__item js-product-item"
            data-analytics="btn-dr-id" [attr.data-digital-river-id]="changeDRId(productDetail.digitialRiverID)">
            <div #priceDiv class="price js-product-price clearfix "></div>
            <div class="price  outside-page">
              <span *ngIf="productDetail.prdStatus != 'nv_notify_me'">{{extractDRPriceIntegerDot(priceDiv,
                drSpinnerCont)}}</span><span *ngIf="productDetail.prdStatus != 'nv_notify_me'"
                class="decimal">{{extractDRPriceDecimal(priceDiv)}}</span>
            </div>
            <div class="buy-padding cta-preorder mobile-top"
              [class.outside-page]="screenWidth === 'LG' || screenWidth === 'XL'" (click)="transmitToCart()">
              <button kuiButton [size]="standard" [danger]="'false'" [type]="'primary'"
                class="featured-buy-link link-btn brand-green cta-button show-out-of-stock" href="javascript:void(0);">
                {{ 'add_to_cart' | translate }}
              </button>
            </div>
            <div class="ship-date"></div>
          </div>
          <div *ngIf="productDetail.prdStatus != 'nv_notify_me'" class="compare-remove-container 50"
            style="padding-bottom: 30px; display: flex; justify-content: space-between;     flex-direction: column;"
            [class.outside-page]="screenWidth === 'LG' || screenWidth === 'XL'">
            <span style="flex:50%" [class.compare]="productDetail.addRemoveCompare === 'Compare'"
              [class.remove]="productDetail.addRemoveCompare === 'Remove'"
              (click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase | translate}}</span>
            <!-- popover *ngIf="productDetail.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="productDetail.stsOfferTxt"></popover -->
            <popover id="53" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'a_o')"
              [screenwidth]="screenWidth" [type]="'a_o'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'a_o')">
            </popover>
            <popover id="54" *ngIf="checkOfferType(productDetail.stsOfferTxt,'e_s')" [screenwidth]="screenWidth"
              [type]="'e_s'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'e_s')"></popover>
            <popover id="55" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'g_b')"
              [screenwidth]="screenWidth" [type]="'g_b'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'g_b')">
            </popover>

            <popover id="57" *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth" [type]="'Availability'"
              [availability]="productDetail.shipInfo"></popover>
          </div>
        </div>
        <div *ngIf="productDetail.digitialRiverID==='4fs|~'">
          <dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
        </div>
        <div class="dr-ck-59"> <!-- *ngIf="!productDetail.digitialRiverID" -->
          <div class="product-details-price-stock">
            <div class="price clearfix h--smallest" *ngIf="locale === 'ru-ru'"><span
                *ngIf="productDetail.prdStatus != 'nv_notify_me'">{{productDetail.currencyCode}}{{productDetail.salePrice}}</span>
            </div>
            <div class="price clearfix h--smallest" *ngIf="locale !== 'ru-ru'">
              <span
                *ngIf="productDetail.prdStatus != 'nv_notify_me'">{{productDetail.currencyCode}}{{getPriceIntegerDot(productDetail.salePrice)}}</span><span
                *ngIf="productDetail.prdStatus != 'nv_notify_me'"
                class="decimal">{{getPriceDecimal(productDetail.salePrice)}}</span>
            </div>
          </div>
          <div *ngIf="screenWidth === 'SM' || screenWidth === 'MD'">
            <div class="buy clearfix" style="padding-bottom: 30px;">
              <span kuiText *ngIf="locale === 'en-us'" class="extra_style nv-buy-link 72"
                [attr.data-pid]="productDetail.productId" [attr.btn-type]="productDetail.prdStatus"
                [attr.data-mpn-code]="getEANCode(productDetail.sku)" data-color="#76b900" data-secondary-color="#fff"
                (click)="productName(productDetail)">{{productDetail.prdStatus | translate }}</span>
              <!-- <input *ngIf="locale !== 'en-us'" type="button" class="buy-link" value="{{productDetail.prdStatus | translate | uppercase}}" (click)="showOverlay(productDetail)" /> -->
              <span kuiText *ngIf="locale !== 'en-us'" class="extra_style nv-buy-link 74"
                [attr.data-pid]="productDetail.productId" [attr.btn-type]="productDetail.prdStatus"
                [attr.data-mpn-code]="getEANCode(productDetail.sku)" data-color="#76b900" data-secondary-color="#fff"
                (click)="productName(productDetail)">{{productDetail.prdStatus | translate }}</span>
            </div>
            <div kuiText *ngIf="productDetail.prdStatus != 'nv_notify_me'" class="compare-remove-container 72"
              style="padding-bottom: 30px; display: flex; justify-content: space-between;     flex-direction: column;">
              <span [class.compare]="productDetail.addRemoveCompare === 'Compare'"
                [class.remove]="productDetail.addRemoveCompare === 'Remove'"
                (click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase |
                translate}}</span>

              <!-- popover *ngIf="productDetail.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="productDetail.stsOfferTxt"></popover -->
              <popover id="80" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'a_o')"
                [screenwidth]="screenWidth" [type]="'a_o'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'a_o')">
              </popover>
              <popover id="81" *ngIf="checkOfferType(productDetail.stsOfferTxt,'e_s')" [screenwidth]="screenWidth"
                [type]="'e_s'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'e_s')"></popover>
              <popover id="82" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'g_b')"
                [screenwidth]="screenWidth" [type]="'g_b'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'g_b')">
              </popover>

            </div>
          </div>
        </div>
      </div>

      <div class="product-details-grid-overview dr-ck-81">
        <div kuiText *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{
          'featured' |
          translate }}</div>
        <div kuiText *ngIf="!productDetail.isFeaturedProduct" class="product-details-featured-product image-cont"
          style="visibility: hidden">{{ 'featured' | translate }}</div>
        <div class="product-details-image-container">
          <kui-image aspectRatio="1-1">
            <img title="{{productDetail.productVariationName}}" src="{{productDetail.imageUrl}}"
              alt="{{productDetail.productVariationName}}" (load)="createThumbnail($event.target)"
              (error)="showImgError($event.target)" />
          </kui-image>
        </div>

        <h2 kuiText class="product-name  h--smallest" id="pt-{{productDetail.productId}}">
          {{productDetail.productVariationName}}
        </h2>

        <div class="specs-container 90"
          [ngClass]="{'specs-container-grid-laptop': productDetail.category === 'LAPTOP'}">
          <ul>
            <li *ngFor="let specs of productDetail.productInfo">
              <div class="specs p-medium" *ngIf="specs.value!=='--' && specs.value!==''">
                <div kuiText style="display: inline-block;">{{specs.name | translate}}:</div>
                <div kuiText style="display: inline-block;">{{specs.value}}</div>
              </div>
            </li>
          </ul>
          <popover *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth" [type]="'Availability'"
            [availability]="productDetail.shipInfo"></popover>


        </div>

        <div class="product-details-price-stock">
          <div class="price clearfix h--smallest" *ngIf="locale === 'ru-ru'">
            {{productDetail.currencyCode}}{{productDetail.salePrice}}</div>
          <div class="price clearfix h--smallest" *ngIf="locale !== 'ru-ru'">
            <span
              *ngIf="productDetail.prdStatus != 'nv_notify_me'">{{productDetail.currencyCode}}{{getPriceIntegerDot(productDetail.salePrice)}}</span><span
              *ngIf="productDetail.prdStatus != 'nv_notify_me'"
              class="decimal">{{getPriceDecimal(productDetail.salePrice)}}</span>
          </div>
        </div>

        <div class="buy clearfix" style="padding-bottom: 30px;">
          <span kuiText *ngIf="locale === 'en-us'" class="extra_style nv-buy-link 117"
            [attr.data-pid]="productDetail.productId" [attr.btn-type]="productDetail.prdStatus" style=""
            [attr.data-mpn-code]="getEANCode(productDetail.sku)" data-color="#76b900" data-secondary-color="#fff"
            (click)="productName(productDetail)">{{productDetail.prdStatus | translate }}</span>
          <!-- <input *ngIf="locale !== 'en-us'" type="button" class="nv-buy-link" value="{{productDetail.prdStatus | translate | uppercase}}" (click)="showOverlay(productDetail)" />-->
          <span kuiText *ngIf="locale !== 'en-us'" class="extra_style nv-buy-link 119"
            [attr.data-pid]="productDetail.productId" [attr.btn-type]="productDetail.prdStatus"
            style="visibility:hidden" [attr.data-mpn-code]="getEANCode(productDetail.sku)" data-color="#76b900"
            data-secondary-color="#fff" (click)="productName(productDetail)">{{productDetail.prdStatus | translate
            }}</span>

        </div>

        <div style="display: flex; justify-content: space-between; flex-wrap: wrap; flex-direction: column; "
          class="115">
          <div *ngIf="productDetail.prdStatus != 'nv_notify_me'" class="compare-remove-container"
            style="padding-bottom: 0px; flex: 50%">
            <span kuiText [class.compare]="productDetail.addRemoveCompare === 'Compare'"
              [class.remove]="productDetail.addRemoveCompare === 'Remove'"
              (click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase | translate}}</span>
          </div>
          <!-- popover *ngIf="productDetail.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="productDetail.stsOfferTxt"></popover -->
          <popover id="128" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'a_o')"
            [screenwidth]="screenWidth" [type]="'a_o'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'a_o')">
          </popover>
          <popover id="129" *ngIf="checkOfferType(productDetail.stsOfferTxt,'e_s')" [screenwidth]="screenWidth"
            [type]="'e_s'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'e_s')"></popover>
          <popover id="130" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'g_b')"
            [screenwidth]="screenWidth" [type]="'g_b'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'g_b')">
          </popover>

        </div>


      </div>


      <div *ngIf="productDetail.digitialRiverID==='4fs|~' && (screenWidth === 'LG' || screenWidth === 'XL')"
        class="product-details-grid-overview" style="display: block;">
        <div kuiText *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{
          'featured' |
          translate }}</div>
        <div *ngIf="!productDetail.isFeaturedProduct" class="product-details-featured-product image-cont"
          style="visibility: hidden">{{ 'featured' | translate }}</div>
        <div class="product-details-image-container">
          <img title="{{productDetail.displayName}} " src="{{productDetail.imageUrl}}"
            alt="{{productDetail.displayName}}" (load)="createThumbnail($event.target)"
            (error)="showImgError($event.target)" />
        </div>

        <h2 kuiText class="product-name  h--smallest" id="pt-{{productDetail.productId}}">{{productDetail.productTitle}}
        </h2>

        <div class="specs-container 136">
          <ul>
            <li *ngFor="let specs of productDetail.productInfo">
              <div class="specs p-medium" *ngIf="specs.value!=='--' && specs.value!==''">
                <div kuiText style="display: inline-block;">{{specs.name | translate}}:</div>
                <div kuiText style="display: inline-block;">{{specs.value}}</div>
              </div>
            </li>
          </ul>

          <!-- <popover *ngIf="productDetail.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="productDetail.stsOfferTxt"></popover>
               <br />
               <popover *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth" [type]="'Availability'" [availability]="productDetail.shipInfo"></popover>
-->
        </div>
        <div #drSpinnerCont *ngIf="productDetail.digitialRiverID==='4fs|~'" class="dr-spinner-bg-grid 148">
          <div #drId class="product-row__item js-product-item" data-analytics="btn-dr-id"
            [attr.data-digital-river-id]="changeDRId(productDetail.digitialRiverID)">
            <div #priceDivOverview class="price js-product-price clearfix"></div>
            <div class="price  outside-page">
              <span>{{extractDRPriceIntegerDot(priceDivOverview, drSpinnerCont)}}</span><span
                class="decimal">{{extractDRPriceDecimal(priceDivOverview)}}</span>
            </div>
            <div class="buy-padding cta-preorder mobile-top" (click)="transmitToCart()">
              <a kuiText class="featured-buy-link link-btn brand-green cta-button show-out-of-stock"
                href="javascript:void(0);">
                {{ 'add_to_cart' | translate }}
              </a>
            </div>
            <div class="ship-date"></div>
          </div>
        </div>
        <div *ngIf="productDetail.digitialRiverID==='4fs|~'">
          <dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
        </div>



        <div style="display: flex; justify-content: space-between; flex-wrap: wrap" class="168">
          <div *ngIf="productDetail.prdStatus != 'nv_notify_me'" class="compare-remove-container"
            style="padding-bottom: 30px; flex: 50%">
            <span kuiText [class.compare]="productDetail.addRemoveCompare === 'Compare'"
              [class.remove]="productDetail.addRemoveCompare === 'Remove'"
              (click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase | translate}}</span>
          </div>
          <!-- popover *ngIf="productDetail.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="productDetail.stsOfferTxt"></popover-->
          <popover id="184" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'a_o')"
            [screenwidth]="screenWidth" [type]="'a_o'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'a_o')">
          </popover>
          <popover id="185" *ngIf="checkOfferType(productDetail.stsOfferTxt,'e_s')" [screenwidth]="screenWidth"
            [type]="'e_s'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'e_s')"></popover>
          <popover id="186" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'g_b')"
            [screenwidth]="screenWidth" [type]="'g_b'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'g_b')">
          </popover>

          <popover *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth" [type]="'Availability'"
            [availability]="productDetail.shipInfo"></popover>
        </div>

      </div>
    </div>
  </div>

  <!-- END OF GRID LAYOUT -->

  <!-- BEGINNING OF LIST VIEW -->

  <div class="product-details-container" *ngIf="layoutType === 'list'">

    <div class="product-details-list-tile" *ngFor="let productDetail of productDetails;">
      <div class="img-col-xl">
        <div kuiText *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{
          'featured' |
          translate }}</div>
        <div class="product-details-image-container-list">
          <img #im title="{{productDetail.productVariationName}}" class="featured-img" src="{{productDetail.imageUrl}}"
            alt="{{productDetail.displayName}}" (window:resize)="createThumbnailList(im)"
            (load)="createThumbnailList(im)" (error)="showImgError($event.target)" />
        </div>
      </div>

      <div class="details-col">
        <div kuiText *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product"
          style="visibility: hidden">{{ 'featured' | translate }}</div>
        <h2 class="name h--smallest" id="pt-{{productDetail.productId}}">{{productDetail.productVariationName}}</h2>
        <div class="specs-container 136"
          [ngClass]="{'specs-container-list-laptop': productDetail.category === 'LAPTOP'}">
          <ul>
            <li *ngFor="let specs of productDetail.productInfo">
              <div kuiText class="specs p-medium" *ngIf="specs.value!=='--' && specs.value">{{specs.name | translate}}:
                {{specs.value}}</div>
            </li>
          </ul>
          <div style="display: flex; justify-content: space-between; flex-direction: column;" class="203">
            <!-- popover *ngIf="productDetail.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="productDetail.stsOfferTxt"></popover -->
            <popover id="220" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'a_o')"
              [screenwidth]="screenWidth" [type]="'a_o'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'a_o')">
            </popover>
            <popover id="221" *ngIf="checkOfferType(productDetail.stsOfferTxt,'e_s')" [screenwidth]="screenWidth"
              [type]="'e_s'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'e_s')"></popover>
            <popover id="222" *ngIf="productDetail.hasStsOffer && checkOfferType(productDetail.stsOfferTxt,'g_b')"
              [screenwidth]="screenWidth" [type]="'g_b'" [bundle]="getOfferTypeText(productDetail.stsOfferTxt,'g_b')">
            </popover>

            <popover *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth" [type]="'Availability'"
              [availability]="productDetail.shipInfo"></popover>
          </div>

        </div>
      </div>
      <div #drSpinnerCont class="buy-col-lg" [class.dr-spinner-bg]="productDetail.digitialRiverID==='4fs|~'">
        <div kuiText *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product"
          style="visibility: hidden">{{ 'featured' | translate }}</div>
        <div *ngIf="!productDetail.digitialRiverID">
          <div class="price clearfix h--smallest" *ngIf="locale === 'ru-ru'"><span
              *ngIf="productDetail.prdStatus != 'nv_notify_me'">{{productDetail.productPrice}}</span></div>
          <div class="price clearfix h--smallest" *ngIf="locale !== 'ru-ru'">
            <span
              *ngIf="productDetail.prdStatus != 'nv_notify_me'">{{productDetail.currencyCode}}{{getPriceIntegerDot(productDetail.salePrice)}}</span><span
              *ngIf="productDetail.prdStatus != 'nv_notify_me'"
              class="decimal">{{getPriceDecimal(productDetail.salePrice)}}</span>
          </div>
          <div class="buy-box">
            <span kuiText *ngIf="locale === 'en-us'" class="extra_style nv-buy-link 237"
              [attr.data-pid]="productDetail.productId" [attr.btn-type]="productDetail.prdStatus"
              style="visibility:hidden" [attr.data-mpn-code]="getEANCode(productDetail.sku)" data-color="#76b900"
              data-secondary-color="#fff" (click)="productName(productDetail)">{{productDetail.prdStatus | translate
              }}</span>
            <!-- <div *ngIf="locale !== 'en-us'" style="display: inline-block; text-align: center;" class="nv-buy-link" (click)="showOverlay(productDetail)">{{productDetail.prdStatus | translate }}</div>-->
            <span kuiText *ngIf="locale !== 'en-us'" class="extra_style nv-buy-link 239"
              [attr.data-pid]="productDetail.productId" [attr.btn-type]="productDetail.prdStatus"
              style="visibility:hidden" [attr.data-mpn-code]="getEANCode(productDetail.sku)" data-color="#76b900"
              data-secondary-color="#fff" (click)="productName(productDetail)">{{productDetail.prdStatus | translate
              }}</span>
            <!-- input type="button" class="nv-buy-link" [attr.btn-type]="productDetail.prdStatus" value="{{productDetail.prdStatus | translate | uppercase}}" (click)="showOverlay(productDetail)" / -->
          </div>
        </div>
        <div #drId *ngIf="productDetail.digitialRiverID==='4fs|~'" class="product-row__item js-product-item"
          data-analytics="btn-dr-id" [attr.data-digital-river-id]="changeDRId(productDetail.digitialRiverID)">
          <div #priceDivList class="price js-product-price clearfix"></div>
          <div class="price  outside-page">
            <span kuiText *ngIf="productDetail.prdStatus != 'nv_notify_me'">{{extractDRPriceIntegerDot(priceDivList,
              drSpinnerCont)}}</span><span *ngIf="productDetail.prdStatus != 'nv_notify_me'"
              class="decimal">{{extractDRPriceDecimal(priceDivList)}}</span>
          </div>
          <div class="buy cta-preorder mobile-top" (click)="transmitToCart()">
            <a kuiText class="featured-buy-link link-btn brand-green  cta-button show-out-of-stock"
              href="javascript:void(0);">
              {{ 'add_to_cart' | translate }}
            </a>
          </div>
          <div class="ship-date"></div>
        </div>
        <div *ngIf="productDetail.digitialRiverID==='4fs|~'">
          <dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
        </div>
        <div *ngIf="productDetail.prdStatus != 'nv_notify_me'" class="compare-remove-container">
          <span kuiText [class.compare]="productDetail.addRemoveCompare === 'Compare'"
            [class.remove]="productDetail.addRemoveCompare === 'Remove'"
            (click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase | translate}}</span>

        </div>
      </div>
    </div>
  </div>
</div>